import { render, staticRenderFns } from "./quotationEdit.vue?vue&type=template&id=4b1a15ee&"
import script from "./quotationEdit.vue?vue&type=script&lang=js&"
export * from "./quotationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports